import React from 'react';
import PropTypes from 'prop-types';
import { mergeClasses, Image } from '@fluentui/react-components';

import { useFolderIconStyle } from './style';

const FolderIconInternal = ({
  thumbnailImageUrl, isEmptyFolder, folderIconRootClassName,
}) => {
  const classes = useFolderIconStyle();
  return (
    <div className={mergeClasses(classes.folderIconContainer, folderIconRootClassName)}>
      <div className={mergeClasses('folder-tag', isEmptyFolder ? classes.emptyFolderTag : classes.folderTag)} />
      <div className={mergeClasses('folder-content', isEmptyFolder ? classes.emptyFolderContent : classes.folderContent)} >
        { thumbnailImageUrl && <Image
          fit="cover"
          src={thumbnailImageUrl}
          alt="folder icon"
        />}
      </div>
    </div>
  );
};

FolderIconInternal.propTypes = {
  thumbnailImageUrl: PropTypes.string,
  folderIconRootClassName: PropTypes.string,
  isEmptyFolder: PropTypes.bool,
};

FolderIconInternal.defaultProps = {
  thumbnailImageUrl: undefined,
  folderIconRootClassName: '',
  isEmptyFolder: false,
};

export const FolderIcon = FolderIconInternal;
